module.exports = __webpack_public_path__ + "static/media/twitterRound.36b0483e.svg";